import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';
import {StorageService} from '../services/storage.service';

@Injectable()
export class AppUrl {
  static get ADMIN_URL(): string {
    return environment.appUrl + 'admin/';
  }

  static get LOGIN(): string {
    return AppUrl.ADMIN_URL + 'login';
  }

  static get SELF(): string {
    return AppUrl.ADMIN_URL + 'self';
  }

  static UPDATE_PASSWORD(): string {
    return AppUrl.ADMIN_URL + 'update-self-password';
  }

  static UPDATE_SELF(): string {
    return AppUrl.ADMIN_URL + 'update-self';
  }

  static LOGOUT(): string {
    return AppUrl.ADMIN_URL + 'logout';
  }

  static UPDATE_PROFILE_IMAGE(): string {
    return AppUrl.ADMIN_URL + 'update-profile-image';
  }

  static FILE_UPLOAD(): string {
    return AppUrl.ADMIN_URL + 'file-upload';
  }

  static MULTIPLE_FILE_UPLOAD(): string {
    return AppUrl.ADMIN_URL + 'file-multiple-upload';
  }

  static COUNTRY(): string {
    return AppUrl.ADMIN_URL + 'countries';
  }

  static USERS(): string {
    return AppUrl.ADMIN_URL + 'user';
  }

  static STATES(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'states/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'states';
  }

  static ADMIN_COUNTS(): string {
    return AppUrl.ADMIN_URL + 'admin-counts';
  }

  static ADMIN_WISE_ADMISSIONS(): string {
    return AppUrl.ADMIN_URL + 'admin-wise-admissions';
  }

  static ADMIN(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'admin/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'admin';
    }
  }

  static ADMIN_COUNT(): string {
    return AppUrl.ADMIN_URL + 'admin-count';
  }

  static ADMIN_STATUS(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'admin-status/' + unique_id;
  }

  static REFERRAL(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'referral/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'referral';
    }
  }

  static REFERRAL_COUNT(): string {
    return AppUrl.ADMIN_URL + 'referral-count';
  }

  static REFERRAL_STATUS(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'referral-status/' + unique_id;
  }

  static ADMIN_CHANGE_PASSWORD(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'admin-password/' + unique_id;
  }

  static EMPLOYEE(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'employee/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'employee';
    }
  }

  static EMPLOYEE_COUNT(): string {
    return AppUrl.ADMIN_URL + 'employee-count';
  }

  static EMPLOYEE_STATUS(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-status/' + unique_id;
  }

  static EMPLOYEE_CHANGE_PASSWORD(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-password/' + unique_id;
  }

  static EMPLOYEE_PROFILE_IMAGE(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-profile-image/' + unique_id;
  }

  static EMPLOYEE_GOVT_PHOTO(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-govt-photo-id/' + unique_id;
  }

  static EMPLOYEE_PAN_IMAGE(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-pan-image/' + unique_id;
  }

  static EMPLOYEE_TENTH_CERTIFICATE(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-tenth-certificate/' + unique_id;
  }

  static EMPLOYEE_TWELTH_CERTIFICATE(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-twelth-certificate/' + unique_id;
  }

  static EMPLOYEE_GRADUATION_CERTIFICATE(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-graduation-certificate/' + unique_id;
  }

  static EMPLOYEE_POST_GRADUATION_CERTIFICATE(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-post-graduation-certificate/' + unique_id;
  }

  static EMPLOYEE_OTHER_QUALIFICATION_CERTIFICATE(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-other-qualification-certificate/' + unique_id;
  }

  static EMPLOYEE_HIGHEST_QUALIFICATION_CERTIFICATE(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-highest-qualification-certificate/' + unique_id;
  }

  static EMPLOYEE_PERSONAL_INFO(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-personal-info/' + unique_id;
  }

  static EMPLOYEE_BANK_INFO(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-bank-info/' + unique_id;
  }

  static EMPLOYEE_ALLOWANCE_INFO(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-allowance-info/' + unique_id;
  }

  static EMPLOYEE_OTHER_INFO(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-other-info/' + unique_id;
  }

  static EMPLOYEE_SALARY_INFO(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-salary-info/' + unique_id;
  }

  static EMPLOYEE_PAYROLL(unique_id: any): string {
    return AppUrl.ADMIN_URL + 'employee-payroll/' + unique_id;
  }

  static ALL_EMPLOYEE_PAYROLL(): string {
    return AppUrl.ADMIN_URL + 'employee-payroll';
  }

  static DOWNLOAD_EMPLOYEE_PAYROLL(): string {
    return AppUrl.ADMIN_URL + 'download-employee-payroll';
  }

  static EMPLOYEE_ASSIGN_HOD(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'employee-hod/' + uniqueId;
  }

  static EMPLOYEE_EVALUATION(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'employee-evaluation/' + uniqueId;
  }

  static EMPLOYEE_ATTENDANCE(): string {
    return AppUrl.ADMIN_URL + 'employee-attendance';
  }

  static EMPLOYEE_ATTENDANCE_COUNT(): string {
    return AppUrl.ADMIN_URL + 'employee-attendance-count';
  }

  static DESIGNATION(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'designation/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'designation';
    }
  }

  static DESIGNATION_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'designation-status/' + uniqueId;
  }

  static DESIGNATION_COUNT(): string {
    return AppUrl.ADMIN_URL + 'designation-count';
  }

  static PROGRAM(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'program/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'program';
  }

  static PROGRAM_COUNT(): string {
    return AppUrl.ADMIN_URL + 'program-count';
  }

  static PROGRAM_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'program-status/' + uniqueId;
  }


  static EVENT(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'events/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'events';
  }

  static EVENT_COUNT(): string {
    return AppUrl.ADMIN_URL + 'events-count';
  }

  static EVENT_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'events-status/' + uniqueId;
  }

  static UNIFORM(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'uniforms/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'uniforms';
  }

  static UNIFORM_COUNT(): string {
    return AppUrl.ADMIN_URL + 'uniforms-count';
  }

  static UNIFORM_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'uniforms-status/' + uniqueId;
  }

  static UNIFORM_TRANSACTION(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'uniforms-transaction/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'uniforms-transaction';
  }

  static UNIFORM_TRANSACTION_COUNT(): string {
    return AppUrl.ADMIN_URL + 'uniforms-transaction-count';
  }

  static UNIFORM_TRANSACTION_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'uniforms-transaction-status/' + uniqueId;
  }


  static UNIFORM_STOCK(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'uniforms-stocks/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'uniforms-stocks';
  }

  static UNIFORM_STOCK_COUNT(): string {
    return AppUrl.ADMIN_URL + 'uniforms-stocks-count';
  }

  static UNIFORM_STOCK_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'uniforms-stocks-status/' + uniqueId;
  }

  static UNIFORM_STOCK_INVOICE_FILE_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'uniforms-stocks-invoice-id/' + uniqueId;
  }


  static EXTRA_CURRICULAR(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'extra-curricular/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'extra-curricular';
  }

  static EXTRA_CURRICULAR_COUNT(): string {
    return AppUrl.ADMIN_URL + 'extra-curricular-count';
  }

  static EXTRA_CURRICULAR_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'extra-curricular-status/' + uniqueId;
  }


  static EXTRA_CURRICULAR_PARTICIPANTS(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'extra-curricular-participant/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'extra-curricular-participant';
  }

  static EXTRA_CURRICULAR_PARTICIPANTS_COUNT(): string {
    return AppUrl.ADMIN_URL + 'extra-curricular-participant-count';
  }


  static TIME_TABLE(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'timetable/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'timetable';
  }

  static INVENTORY_CATEGORY(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'inventory-category/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'inventory-category';
  }

  static INVENTORY_CATEGORY_COUNT(): string {
    return AppUrl.ADMIN_URL + 'inventory-category-count';
  }

  static INVENTORY_CATEGORY_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'inventory-category-status/' + uniqueId;
  }

  static INVENTORY(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'inventory/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'inventory';
  }

  static INVENTORY_COUNT(): string {
    return AppUrl.ADMIN_URL + 'inventory-count';
  }

  static INVENTORY_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'inventory-status/' + uniqueId;
  }

  static INVENTORY_STOCK(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'inventory-stock/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'inventory-stock';
  }

  static INVENTORY_STOCK_COUNT(): string {
    return AppUrl.ADMIN_URL + 'inventory-stock-count';
  }

  static INVENTORY_STOCK_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'inventory-stock-status/' + uniqueId;
  }

  static INVENTORY_STOCK_INVOICE_ID(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'inventory-stock-invoice-id/' + uniqueId;
  }

  static INVENTORY_TRANSACTION(uniqueId?: any): string {
    if (uniqueId)
      return AppUrl.ADMIN_URL + 'inventory-stock-transaction/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'inventory-stock-transaction';
  }

  static INVENTORY_TRANSACTION_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'inventory-stock-transaction-status/' + uniqueId;
  }

  static BOOK_CATEGORY(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'book-category/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'book-category';
  }

  static BOOK_CATEGORY_COUNT(): string {
    return AppUrl.ADMIN_URL + 'book-category-count';
  }

  static BOOK_CATEGORY_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'book-category-status/' + uniqueId;
  }

  static BOOK(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'book/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'book';
  }

  static BOOK_IMAGE(uniqueId?: any): string {
    return AppUrl.ADMIN_URL + 'book-image/' + uniqueId;
  }

  static BOOK_COUNT(): string {
    return AppUrl.ADMIN_URL + 'book-count';
  }

  static BOOK_BY_ISBN(): string {
    return AppUrl.ADMIN_URL + 'book-by-isbn';
  }

  static BOOK_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'book-status/' + uniqueId;
  }

  static BOOK_COVER_IMAGE(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'book-cover-image-id/' + uniqueId;
  }

  static BOOK_STOCK(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'book-stock/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'book-stock';
  }

  static BOOK_STOCK_COUNT(): string {
    return AppUrl.ADMIN_URL + 'book-stock-count';
  }

  static BOOK_STOCK_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'book-stock-status/' + uniqueId;
  }

  static BOOK_STOCK_INVOICE_ID(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'book-stock-invoice-id/' + uniqueId;
  }

  static BOOK_TRANSACTION(uniqueId?: any): string {
    if (uniqueId)
      return AppUrl.ADMIN_URL + 'book-stock-transaction/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'book-stock-transaction';
  }

  static BOOK_TRANSACTION_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'book-stock-transaction-status/' + uniqueId;
  }

  static BOOK_LIBRARY(uniqueId?: any): string {
    if (uniqueId)
      return AppUrl.ADMIN_URL + 'library/' + uniqueId;
    else
      return AppUrl.ADMIN_URL + 'library';
  }

  static BOOK_RETURN(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'library-return/' + uniqueId;
  }

  static BOOK_LIBRARY_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'library-status/' + uniqueId;
  }

  static BOOK_LIBRARY_TRANSACTION(uniqueId?: any): string {
    if (uniqueId)
      return AppUrl.ADMIN_URL + 'library-transaction/' + uniqueId;
    else
      return AppUrl.ADMIN_URL + 'library-transaction';
  }

  static BOOK_LIBRARY_TRANSACTION_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'library-transaction-status/' + uniqueId;
  }

  static COURSE(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'course/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'course';
  }

  static COURSE_COUNT(): string {
    return AppUrl.ADMIN_URL + 'course-count';
  }

  static COURSE_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'course-status/' + uniqueId;
  }

  static BRANCH(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'branch/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'branch';
  }

  static BRANCH_COUNT(): string {
    return AppUrl.ADMIN_URL + 'branch-count';
  }

  static BRANCH_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'branch-status/' + uniqueId;
  }

  static SESSION(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'session/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'session';
  }

  static DEFAULT_SESSION(uniqueId?): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'default-session/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'default-session';
    }
  }

  static SESSION_COUNT(): string {
    return AppUrl.ADMIN_URL + 'session-count';
  }

  static SESSION_STATUS(uniqueId: any, status: any): string {
    if (status == 'default_session')
      return AppUrl.ADMIN_URL + 'default-session';
    else if (status == 're-registration-session')
      return AppUrl.ADMIN_URL + 're-registration-session/' + uniqueId;
    else if (status == 're-registration-entry-session')
      return AppUrl.ADMIN_URL + 're-registration-entry-session/' + uniqueId;
    else if (status == 'admission-session')
      return AppUrl.ADMIN_URL + 'admission-session/' + uniqueId;
    else if (status == 're-opened-session')
      return AppUrl.ADMIN_URL + 're-opened-session/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'session-status/' + uniqueId;
  }

  static PCB_MAPPING(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'pcb-mapping/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'pcb-mapping';
  }

  static PCB_MAPPING_BY_ID(id: any): string {
    return AppUrl.ADMIN_URL + 'pcb-mapping-by-id/' + id;
  }

  static PCB_MAPPING_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'pcb-mapping-status/' + uniqueId;
  }

  static PCBS_MAPPING(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'pcbs-mapping/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'pcbs-mapping';
  }

  static PCBS_MAPPING_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'pcbs-mapping-status/' + uniqueId;
  }

  static FEE_STRUCTURE(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'fee-structure/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'fee-structure';
    }
  }

  static FEE_STRUCTURE_PCB(): string {
    return AppUrl.ADMIN_URL + 'fee-structure-by-pcb';
  }

  static SUBJECT(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'subject/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'subject';
  }

  static SUBJECT_GROUPING(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'subject-group/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'subject-group';
  }

  static SUBJECT_COUNT(): string {
    return AppUrl.ADMIN_URL + 'subject-count';
  }

  static SUBJECT_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'subject-status/' + uniqueId;
  }


  static EVENT_PARTICIPANTS(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'event-participants/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'event-participants';
  }


  static EVENT_PARTICIPANTS_COUNT(): string {
    return AppUrl.ADMIN_URL + 'event-participants-count';
  }

  static EVENT_PARTICIPANTS_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'event-participants-status/' + uniqueId;
  }

  static EVENT_PARTICIPANTS_FILE_ID(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'event-participants-file/' + uniqueId;
  }

  static VISITOR(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'visitors/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'visitors';
  }


  static VISITOR_COUNT(): string {
    return AppUrl.ADMIN_URL + 'visitors-count';
  }

  static VISITOR_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'visitors-status/' + uniqueId;
  }

  static VISITOR_FILE_ID(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'visitors-govt-photo/' + uniqueId;
  }


  static SUBJECT_GROUPING_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'subject-group-status/' + uniqueId;
  }


  static CHAPTER(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'chapters/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'chapters';
  }

  static CLASS(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'classes/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'classes';
  }

  static SECTION(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'section/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'section';
  }

  static CHAPTER_COUNT(): string {
    return AppUrl.ADMIN_URL + 'chapters-count';
  }

  static CHAPTER_ASSIGNMENT(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'chapters-assignment/' + uniqueId;
  }

  static CHAPTER_NOTE(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'chapters-note/' + uniqueId;
  }

  static CHAPTER_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'chapters-status/' + uniqueId;
  }

  static CLASS_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'classes-status/' + uniqueId;
  }

  static SECTION_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'section-status/' + uniqueId;
  }

  static SCHOLARSHIP(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'scholarship/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'scholarship';
    }
  }

  static SCHOLARSHIP_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'scholarship-status/' + uniqueId;
  }

  static STUDENT(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'student/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'student';
    }
  }

  static EMPLOYEE_SUBJECT_MAPPING(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'employee-subject-mapping/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'employee-subject-mapping';
  }

  static EMPLOYEE_SUBJECT_MAPPING_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'employee-subject-mapping-status/' + uniqueId;
  }


  static STUDENT_BY_ENROLLMENT(): string {
    return AppUrl.ADMIN_URL + 'student-roll-number';
  }

  static STUDENT_COUNT(): string {
    return AppUrl.ADMIN_URL + 'student-count';
  }

  static STUDENT_PERSONAL_INFO(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'student/' + uniqueId;
  }

  static STUDENT_PHOTOGRAPH(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'student-photograph/' + uniqueId;
  }

  static STUDENT_GOVT_PHOTO_ID(uniqueId: any): string {
    return (
      AppUrl.ADMIN_URL + 'student-govt-photo/' + uniqueId
    );
  }

  static STUDENT_SIGNATURE(uniqueId: any): string {
    return (
      AppUrl.ADMIN_URL + 'student-signature/' + uniqueId
    );
  }

  static STUDENT_PREVIOUS_SCHOOL_CERTIFICATE(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'student-certificate/' + uniqueId;
  }

  static STUDENT_ADDRESS_INFO(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'student-address/' + uniqueId;
  }

  static STUDENT_ACADEMIC_DETAIL(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'student-academic/' + uniqueId;
  }

  static PARENT(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'parent/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'parent';
    }
  }

  static PARENT_COUNT(): string {
    return AppUrl.ADMIN_URL + 'parent-count';
  }

  static PARENT_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'parent-status/' + uniqueId;
  }

  static PARENT_PERSONAL_INFO(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'parent/' + uniqueId;
  }

  static PARENT_PHOTOGRAPH(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'parent-photograph/' + uniqueId;
  }

  static PARENT_GOVT_PHOTO_ID(uniqueId: any): string {
    return (
      AppUrl.ADMIN_URL + 'parent-govt-photo/' + uniqueId
    );
  }

  static PARENT_SIGNATURE(uniqueId: any): string {
    return (
      AppUrl.ADMIN_URL + 'parent-signature/' + uniqueId
    );
  }

  static PARENT_ADDRESS_INFO(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'parent-address/' + uniqueId;
  }

  static PARENT_TENTH_CERTIFICATE(uniqueId: any): string {
    return (
      AppUrl.ADMIN_URL + 'parent-tenth/' + uniqueId
    );
  }

  static PARENT_TWELTH_CERTIFICATE(uniqueId: any): string {
    return (
      AppUrl.ADMIN_URL + 'parent-twelfth/' + uniqueId
    );
  }


  static PARENT_GRADUATION_CERTIFICATE(uniqueId: any): string {
    return (
      AppUrl.ADMIN_URL + 'parent-graduation/' + uniqueId
    );
  }


  static PARENT_POST_GRADUATION_CERTIFICATE(uniqueId: any): string {
    return (
      AppUrl.ADMIN_URL + 'parent-post-graduation/' + uniqueId
    );
  }


  static SUBJECT_SLM_ID(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'subject-slm/' + uniqueId;
  }

  static SUBJECT_NOTE_ID(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'subject-note/' + uniqueId;
  }

  static STUDENT_TRANSACTION(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'student-transaction/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'student-transaction';
    }
  }

  static STUDENT_ASSIGN_HOSTEL(uniqueId?: any): string {
    return AppUrl.ADMIN_URL + 'student-assign-hostel/' + uniqueId;
  }

  static STUDENT_ASSIGN_VEHICLE(uniqueId?: any): string {
    return AppUrl.ADMIN_URL + 'student-assign-vehicle/' + uniqueId;
  }

  static STUDENT_ENROLLMENT(): string {
    return AppUrl.ADMIN_URL + 'assign-enrollment';
  }

  static VERIFY_STUDENT(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'student-verify/' + uniqueId;
  }

  static REJECT_STUDENT(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'student-reject/' + uniqueId;
  }

  static DOCUMENT_REQUIRED_STUDENT(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'student-document-required/' + uniqueId;
  }

  static STUDENT_RESULT(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'student-result/' + uniqueId;
  }

  static STUDENT_ATTENDANCE(): string {
    return AppUrl.ADMIN_URL + 'student-attendance';
  }

  static STUDENT_ATTENDANCE_COUNT(): string {
    return AppUrl.ADMIN_URL + 'student-attendance-count';
  }

  static HOSTEL(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'hostel/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'hostel';
    }
  }

  static HOSTEL_COUNT(): string {
    return AppUrl.ADMIN_URL + 'hostel-count';
  }

  static HOSTEL_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'hostel-status/' + uniqueId;
  }

  static HOSTEL_ROOM(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'hostel-room/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'hostel-room';
    }
  }

  static HOSTEL_ROOM_COUNT(): string {
    return AppUrl.ADMIN_URL + 'hostel-room-count';
  }

  static HOSTEL_ROOM_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'hostel-room-status/' + uniqueId;
  }

  static HOSTEL_MENU(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'hostel-menu/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'hostel-menu';
    }
  }

  static HOSTEL_MENU_COUNT(): string {
    return AppUrl.ADMIN_URL + 'hostel-menu-count';
  }

  static HOSTEL_MENU_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'hostel-menu-status/' + uniqueId;
  }

  static VEHICLE(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'vehicle/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'vehicle';
    }
  }

  static VEHICLE_COUNT(): string {
    return AppUrl.ADMIN_URL + 'vehicle-count';
  }

  static VEHICLE_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'vehicle-status/' + uniqueId;
  }

  static VEHICLE_DRIVER(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'vehicle-driver/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'vehicle-driver';
    }
  }

  static VEHICLE_DRIVER_COUNT(): string {
    return AppUrl.ADMIN_URL + 'vehicle-driver-count';
  }

  static VEHICLE_DRIVER_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'vehicle-driver-status/' + uniqueId;
  }

  static VEHICLE_ROUTE(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'vehicle-route/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'vehicle-route';
    }
  }


  static ALUMNI(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'alumni/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'alumni';
    }
  }

  static ALUMNI_IMAGES(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'alumni-activity-images/' + uniqueId;
    }
  }

  static ALUMNI_COUNT(): string {
    return AppUrl.ADMIN_URL + 'alumni-count';
  }

  static ALUMNI_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'alumni-status/' + uniqueId;
  }

  static ALUMNI_ACTIVITY(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'alumni-activity/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'alumni-activity';
    }
  }

  static ALUMNI_ACTIVITY_IMAGE(uniqueId?: any): string {
    return AppUrl.ADMIN_URL + 'alumni-activity-images/' + uniqueId;
  }

  static ALUMNI_ACTIVITY_COUNT(): string {
    return AppUrl.ADMIN_URL + 'alumni-activity-count';
  }

  static ALUMNI_ACTIVITY_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'alumni-activity-status/' + uniqueId;
  }

  static SUPPORT_TICKET(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'support-ticket/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'support-ticket';
    }
  }

  static SUPPORT_TICKET_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'support-ticket-status/' + uniqueId;
  }

  static SUPPORT_TICKET_IMAGE(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'support-ticket-image/' + uniqueId;
  }

  static STUDENT_SUPPORT_TICKET(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'support-ticket-student/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'support-ticket-student';
    }
  }

  static STUDENT_SUPPORT_TICKET_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'support-ticket-student-status/' + uniqueId;
  }

  static STUDENT_SUPPORT_TICKET_IMAGE(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'support-ticket-student-image/' + uniqueId;
  }


  static PARENT_SUPPORT_TICKET(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'support-ticket-student/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'support-ticket-student';
    }
  }

  static PARENT_SUPPORT_TICKET_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'support-ticket-student-status/' + uniqueId;
  }

  static PARENT_SUPPORT_TICKET_IMAGE(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'support-ticket-student-image/' + uniqueId;
  }


  static RECEIPT(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'receipt/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'receipt';
    }
  }

  static RECEIPT_TRANSACTION(): string {
    return AppUrl.ADMIN_URL + 'receipt-transactions';
  }

  static WALLET_TRANSACTION(): string {
    return AppUrl.ADMIN_URL + 'wallet-transactions';
  }

  static STUDENT_ASSIGNMENT(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'assignment/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'assignment';
    }
  }

  static STUDENT_ASSIGNMENT_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'assignment-status/' + uniqueId;
  }

  static HOLIDAY(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'holiday/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'holiday';
    }
  }

  static PERMISSION(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'permission/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'permission';
    }
  }

  static PERMISSION_COUNT(): string {
    return AppUrl.ADMIN_URL + 'permission-count';
  }

  static PERMISSION_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'permission-status/' + uniqueId;
  }

  static SUB_PERMISSION(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'sub-permission/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'sub-permission';
    }
  }

  static SUB_PERMISSION_COUNT(): string {
    return AppUrl.ADMIN_URL + 'sub-permission-count';
  }

  static SUB_PERMISSION_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'sub-permission-status/' + uniqueId;
  }

  static DESIGNATION_PERMISSION(uniqueId?: any): string {
    if (uniqueId) {
      return AppUrl.ADMIN_URL + 'designation-permission/' + uniqueId;
    } else {
      return AppUrl.ADMIN_URL + 'designation-permission';
    }
  }

  static DESIGNATION_PERMISSION_STATUS(uniqueId: any): string {
    return AppUrl.ADMIN_URL + 'designation-permission-status/' + uniqueId;
  }

  static HOME_COUNTS(): string {
    return AppUrl.ADMIN_URL + 'home-counts';
  }

  static GENERAL_COUNTS(): string {
    return AppUrl.ADMIN_URL + 'general-counts';
  }

  static EMPLOYEE_REPORT_COUNTS(): string {
    return AppUrl.ADMIN_URL + 'employee-counts';
  }

  static MODULE_REPORT_COUNTS(): string {
    return AppUrl.ADMIN_URL + 'module-counts';
  }

  static INVENTORY_REPORT_COUNTS(): string {
    return AppUrl.ADMIN_URL + 'inventory-counts';
  }

  static BOOK_REPORT_COUNTS(): string {
    return AppUrl.ADMIN_URL + 'book-counts';
  }

  static LIBRARY_REPORT_COUNTS(): string {
    return AppUrl.ADMIN_URL + 'library-counts';
  }

  static STUDENT_REPORT_COUNTS(): string {
    return AppUrl.ADMIN_URL + 'student-counts';
  }
  static DOWNLOAD_STUDENT_COUNT(): string {
    return AppUrl.ADMIN_URL + 'download-student-count';
  }

  static ACCOUNT_REPORT_COUNTS(): string {
    return AppUrl.ADMIN_URL + 'account-counts';
  }

  static UTILITY_REPORT_COUNTS(): string {
    return AppUrl.ADMIN_URL + 'utility-counts';
  }

  static TICKET_REPORT_COUNTS(): string {
    return AppUrl.ADMIN_URL + 'ticket-counts';
  }

  static NOTIFICATION_REPORT_COUNTS(): string {
    return AppUrl.ADMIN_URL + 'notification-counts';
  }

  static NOTIFY(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'notify/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'notification';
  }

  static NOTIFY_COUNT(): string {
    return AppUrl.ADMIN_URL + 'notify-count';
  }

  static STUDENT_NOTIFY(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'notify/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'student-notification';
  }

  static STUDENT_NOTIFY_COUNT(): string {
    return AppUrl.ADMIN_URL + 'student-notify-count';
  }

  static PARENT_NOTIFY(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'notify/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'parent-notification';
  }

  static PARENT_NOTIFY_COUNT(): string {
    return AppUrl.ADMIN_URL + 'parent-notification-count';
  }

  static LEAVE(uniqueId?: any): string {
    if (uniqueId) return AppUrl.ADMIN_URL + 'leave/' + uniqueId;
    else return AppUrl.ADMIN_URL + 'leave';
  }


  static LEAVE_ADMIN_STATUS(uniqueId?: any): string {
    return AppUrl.ADMIN_URL + 'leave-admin-status/' + uniqueId;
  }

}
